var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view dashboard"},[_c('section',{staticClass:"landing"},[_c('div',{attrs:{"id":"edit"}},[_c('edit')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }